export const CLINICAL_TEXT_FIELDS = ['anamnesis', 'clinicalNotes'];
export const CLINICAL_LIST_FIELDS = ['clinicalConditions', 'allergies', 'contraindications', 'medicalTreatments', 'protocols'];
export const CLINICAL_FIELDS = [...CLINICAL_TEXT_FIELDS, ...CLINICAL_LIST_FIELDS, 'responsibleProfessionalId'];
export const clinicalPersonName = (person) => [person?.name, person?.surname].filter(Boolean).join(' ') || `#${person?.id}`;
export const clinicalLines = (value) => String(value || '').split(/\r?\n/).map((item) => item.trim()).filter(Boolean);

export function validateClinicalRecord(value, clientId) {
  if (!value || value.client?.id !== clientId || !Object.prototype.hasOwnProperty.call(value, 'updatedAt')
    || (value.updatedAt !== null && (typeof value.updatedAt !== 'string' || !Number.isFinite(Date.parse(value.updatedAt))))
    || CLINICAL_TEXT_FIELDS.some((key) => value[key] != null && typeof value[key] !== 'string')
    || CLINICAL_LIST_FIELDS.some((key) => !Array.isArray(value[key]) || value[key].some((item) => typeof item !== 'string'))
    || (value.responsibleProfessional != null && !Number.isSafeInteger(value.responsibleProfessional.id))) throw new Error('spa.clinical.invalidResponse');
  return value;
}
export function clinicalForm(record) {
  return { ...Object.fromEntries(CLINICAL_TEXT_FIELDS.map((key) => [key, record[key] || ''])),
    ...Object.fromEntries(CLINICAL_LIST_FIELDS.map((key) => [key, record[key].join('\n')])),
    responsibleProfessionalId: record.responsibleProfessional?.id ? String(record.responsibleProfessional.id) : '' };
}
export function clinicalFormValid(form) {
  return form && CLINICAL_TEXT_FIELDS.every((key) => typeof form[key] === 'string' && form[key].length <= 20000)
    && CLINICAL_LIST_FIELDS.every((key) => { const lines = clinicalLines(form[key]); return lines.length <= 200 && lines.every((line) => line.length <= 500)
      && new Set(lines.map((line) => line.toLowerCase())).size === lines.length; })
    && (form.responsibleProfessionalId === '' || (Number.isSafeInteger(Number(form.responsibleProfessionalId)) && Number(form.responsibleProfessionalId) > 0));
}
function values(form) {
  return { ...Object.fromEntries(CLINICAL_TEXT_FIELDS.map((key) => [key, form[key].trim() || null])),
    ...Object.fromEntries(CLINICAL_LIST_FIELDS.map((key) => [key, clinicalLines(form[key])])),
    responsibleProfessionalId: form.responsibleProfessionalId === '' ? null : Number(form.responsibleProfessionalId) };
}
export function clinicalPatch(baseline, draft) {
  if (!clinicalFormValid(draft)) return null;
  const before = values(baseline); const after = values(draft);
  return Object.fromEntries(CLINICAL_FIELDS.filter((key) => JSON.stringify(before[key]) !== JSON.stringify(after[key])).map((key) => [key, after[key]]));
}
export function validateClinicalList(data, type, clientId) {
  if (!Array.isArray(data) || data.some((item) => !Number.isSafeInteger(item?.id) || item.id <= 0
    || (type === 'history' && (!item.before || !item.after || item.after.client?.id !== clientId || item.before.client?.id !== clientId))
    || (type === 'consents' && (!['PENDING', 'SIGNED', 'REVOKED'].includes(item.status) || typeof item.title !== 'string' || typeof item.version !== 'string'))
    || (type === 'documents' && (typeof item.name !== 'string' || typeof item.mimeType !== 'string' || !Number.isFinite(item.sizeBytes))))) throw new Error('spa.clinical.invalidResponse');
  return data;
}
